import API from "../../../app/api";

export const getHomepage = async () => {
  try {
    const res = await API.get("banners/hero");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Home Page");
    }
    return res.data.data;
  } catch (error) {
    console.error("getHomepage error:", error);
    throw error;
  }
};
